import type {TGetGameTimeResponse} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import {GetApi} from '~/api/client'
import MockConfig from '~/api/mocks/config'

const endpoint = endpoints.gameplay.getGameTime

export default class GetGameTime extends GetApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected getMockResponse(): TGetGameTimeResponse {
    return {time: MockConfig.time}
  }

  protected transformResponse(r: TGetGameTimeResponse) {
    return r
  }

  public mocksRequireLogin() {
    return true
  }
}
